import { render, staticRenderFns } from "./FCSourceTable.vue?vue&type=template&id=50ab41ce&"
import script from "./FCSourceTable.vue?vue&type=script&lang=js&"
export * from "./FCSourceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports